// extracted by mini-css-extract-plugin
export var root = "SectionHeading-module--root--64029";